import CryptoJS from 'crypto-js';

export const getDailyPuzzleDocumentId = (date: Date) => {
  const year = String(date.getFullYear());
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return CryptoJS.SHA1(`${year}${month}${day}`).toString();
};
